import type { RelayTask, TaskState } from '@continuum/show-core';
import { mono, sans } from '../ui/atoms.js';
import type { ScreenCopy } from '../ui/screenText.js';

/**
 * The one that is not really a game: a code, and the name of someone who has to hear you say
 * it. It is the only game that makes two guests turn and talk, which is the whole point of the
 * evening. The name comes first, because nobody knows the seat numbers.
 */
export function Relay({
  relay,
  accent,
  onWin,
  nameOf,
  s,
}: {
  task: RelayTask;
  relay: TaskState['relay'];
  accent: string;
  onProgress: (p: number) => void;
  onWin: () => void;
  nameOf: (seat: number) => string | null;
  s: ScreenCopy;
}) {
  const seat = relay ? String(relay.toSeat).padStart(2, '0') : '';
  const name = relay ? (nameOf(relay.toSeat) ?? '') : '';
  return (
    <div style={{ marginTop: 22, textAlign: 'center' }}>
      <div style={{ fontFamily: mono, fontSize: 12, letterSpacing: 1.5, color: '#9db3c2' }}>{s.relayShowTo}</div>
      <div style={{ marginTop: 6, fontFamily: sans, fontSize: 28, fontWeight: 700, letterSpacing: 3, color: accent }}>
        {relay ? s.relayWho(name, seat) : '…'}
      </div>
      <div style={{ margin: '18px auto 0', display: 'inline-flex' }}>
        <span
          style={{
            padding: '12px 16px',
            border: `1.5px solid ${accent}`,
            borderRadius: 8,
            fontSize: 30,
            fontWeight: 700,
            letterSpacing: 8,
          }}
        >
          {relay?.code ?? '····'}
        </span>
      </div>
      <div style={{ marginTop: 14, fontFamily: mono, fontSize: 13, color: '#9db3c2', lineHeight: 1.55 }}>{s.relayThen}</div>
      <button
        onClick={onWin}
        style={{
          marginTop: 18,
          minHeight: 52,
          padding: '0 22px',
          borderRadius: 12,
          border: `1px solid ${accent}`,
          background: 'transparent',
          color: accent,
          fontFamily: sans,
          fontSize: 15,
          fontWeight: 700,
          letterSpacing: 1.5,
        }}
      >
        {s.relayDone}
      </button>
    </div>
  );
}
